<div
  class="form-group"
  [formGroup]="formGroup!"
>
  <label
    for="{{ config?.name }}"
    class="mb-1 fw-bold"
  >
    {{ config?.label }}
    @if (config ? showAsterisk(config) : false) {
      *
    }
  </label>

  @if (config?.additionalText) {
    <p
      id="{{ config!.name + '-text' }}"
      class="form-text text-muted mt-0 mb-2"
    >
      {{ config!.additionalText }}
    </p>
  }

  <div class="input-group">
    <input
      #d="ngbDatepicker"
      class="form-control"
      ngbDatepicker
      [attr.placeholder]="config?.placeholder"
      [id]="config?.name"
      [formControlName]="config?.name ?? null"
      [attr.aria-describedby]="config?.name + 'err'"
      [ngClass]="{ 'is-valid': valid, 'is-invalid': invalid }"
      (dateSelect)="onDateChange()"
      (change)="onDateChange()"
    />
    <button
      type="button"
      class="btn btn-colour-blue-600"
      [id]="config?.name + '_picker_btn'"
      (click)="d.toggle()"
    >
      <i class="fa fa-calendar"></i>
    </button>
  </div>

  <div
    libFormFieldError
    [fieldConfig]="config!"
    [formComponent]="fc"
  ></div>
</div>
